import React, { useEffect, useState } from 'react';
import { useIntl } from 'umi';
import moment from 'moment';

import {
  Justify,
  Col,
  Row,
} from 'tea-component';

import ItemCard from './ItemCard';
import { getFunnelStep } from '@/pages/dashboard/services/funnel';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import useStepOptions from "@/pages/dashboard/pages/funnel/_config/useStepOptions";
import { formatFunnelFilterValues } from '../../_config/utils';

const FunnelStep = (props: any) => {
  const { filterLoading, formValue, gameCode, pageType } = props;
  const { formatMessage } = useIntl();
  const stepOptions = useStepOptions(formValue);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const time = moment(formValue?.filterValue?.rangeTime?.[1]).format("YYYY-MM-DD") || '';

  useEffect(() => {
    if (filterLoading) return;
    getCardData(formValue);
  }, [formValue, filterLoading]);

  const getCardData = (formValue: any) => {
    setError(false);
    setLoading(true);
    const { filterValue } = formValue || {};
    const { rangeTime, ...filters } = filterValue || {};
    const startTime = filterValue?.rangeTime?.[0];
    const endTime = filterValue?.rangeTime?.[1];
    const params = {
      game_code: gameCode,
      period: 'daily',
      start_time: moment(startTime).format("YYYY-MM-DD"),
      end_time: moment(endTime).format("YYYY-MM-DD"),
      filters: formatFunnelFilterValues(filters),
    };
    getFunnelStep(params, pageType).then((res) => {
      setLoading(false);
      setCardData(res?.card_list);
    }).catch(() => {
      setCardData([]);
      setLoading(false);
      setError(true);
    });
  };

  return (
    <>
      <Justify
        className="register-funnel-justify"
        left={
          <div className="register-funnel-title">{formatMessage({ id: 'funnel_device_conversion' })}</div>
        }
        right={<div className="register-funnel-time">{time}</div>}
      />
      <Abnormal
        isLoading={loading}
        isError={error}
        component={
          <>
            <Row>
              {cardData?.map((e, i) => {
                return (
                  <Col key={i} span={4} className="register-funnel-col">
                    <ItemCard data={e} index={i} stepOptions={stepOptions} />
                  </Col>
                );
              })}
            </Row>
          </>
        }
        style={{ height: 332, background: '#fff', marginTop: 20, marginBottom: 20 }}
      />
    </>
  );
};

export default FunnelStep;